import { Stack } from '@chakra-ui/react';
import {
  RiMenu2Fill,
  RiMoneyDollarCircleLine,
  RiRoadMapLine,
} from 'react-icons/ri';

import { useCan } from '../../../../hooks/useCan';
import { NavLink } from '../NavLink';
import { NavSection } from '../NavSection';

export function SidebarNavExpenses() {
  const userCanSeeKmControl = useCan({
    permissions: ['km_control_access'],
  });

  return (
    <Stack spacing="12" align="flex-start">
      <NavSection title="GERAL">
        <NavLink to="/menu" icon={RiMenu2Fill}>
          Menu
        </NavLink>
      </NavSection>

      <NavSection title="RESSARCIMENTO">
        <NavLink to="/miles/expenses" icon={RiMoneyDollarCircleLine}>
          Despesas e Reembolsos
        </NavLink>

        {userCanSeeKmControl && (
          <NavLink to="/miles/km-control" icon={RiRoadMapLine}>
            Controle de KM
          </NavLink>
        )}
      </NavSection>
    </Stack>
  );
}
